module.exports = __webpack_public_path__ + "img/icon-minimize-2.f3266322.svg";